<app-navbar-style-one></app-navbar-style-one>

<div class="menu-page account-section">
    <div class="container-fluid">
        <div class="content-wrapper">
            <!-- Left Image -->
            <div class="left-image">
                <img src="../../../assets/img/home2/header1.jpg" alt="Chef seasoning steak">
            </div>

            <!-- Center Content -->
            <div class="center-content">
                <h2>{{ 'Make It Your Way' | titlecase}}</h2>
                <p>
                    Choose the ingredients, style, and extras – your order, your rules
                </p>
            </div>

            <!-- Right Images -->
            <div class="right-images">
                <img src="../../../assets/img/home2/header3.jpg" alt="Stuffed mushroom dish">
                <img src="../../../assets/img/home2/header2.jpg" alt="Gourmet burger with fries">
            </div>
        </div>
    </div>
</div>

<section class="custom-foodSection mt-4 mb-5">
    <div class="container-fluid">
        <!-- Product Selection -->
        <div class="row mb-4">
            <div class="col-12">
                <h2 class="text-center mb-4">
                    <span class="brush">What would you like to customize?</span>
                </h2>
                <div class="d-flex create-overflow-scroll">
                    <div class="btn-group" role="group">
                        <button *ngFor="let category of categories" 
                            type="button" 
                            class="btn btn-outline-primary"
                            [class.active]="selectedCategory?.id === category.id"
                            (click)="selectCategory(category)">
                            <img [src]="category.avatar" [alt]="category.name" class="d-block" style="width: 100%;">
                            {{ category.name | titlecase }}
                            <span class="start-now d-block mt-3 mb-3">Start Now</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Size Selection (Moved to top when category has sizes) -->
        <div *ngIf="selectedCategory && selectedCategory.has_sizes && selectedCategory.sizes?.length > 0" class="row mb-4">
            <div class="col-12">
                <h3 class="text-center mb-3">Choose Size</h3>
                <div class="d-flex justify-content-center flex-wrap">
                    <div *ngFor="let size of selectedCategory.sizes" class="me-2 mb-2">
                        <button class="btn size-btn"
                                [class.btn-primary]="selectedSize?.id === size.id"
                                [class.btn-outline-secondary]="selectedSize?.id !== size.id"
                                (click)="selectSize(size)">
                            <span class="size-name">{{ size.name | titlecase }}</span>
                            <span class="size-price ps-2"> (${{ size.price }})</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Subcategory Selection -->
        <div *ngIf="selectedCategory && subCategories.length > 0" class="row mb-4">
            <div class="col-12">
                <h3 class="text-center mb-3">Choose Type</h3>
                <div class="d-flex justify-content-center flex-wrap">
                    <div *ngFor="let subCat of subCategories" class="me-2 mb-2">
                        <button class="btn"
                                [class.btn-primary]="selectedSubCategory?.id === subCat.id"
                                [class.btn-outline-secondary]="selectedSubCategory?.id !== subCat.id"
                                (click)="selectSubCategory(subCat)">
                            <img [src]="subCat.avatar" [alt]="subCat.name" style="width: 25px; height: 25px; margin-right: 5px;">
                            {{ subCat.name | titlecase }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Customization Area -->
        <div *ngIf="selectedCategory && selectedSubCategory" class="row">
            <!-- Redesigned Ingredients Panel -->
            <div class="col-md-4 mt-3">
                <div class="pizza-card">
                    <!-- Toggle Section -->
                    <div class="toggle-container" *ngIf="selectedCategory?.name?.toLowerCase() === 'pizza'">
                        <div class="toggle-switch" 
                            [class.active]="isHalfAndHalfMode"
                            (click)="toggleHalfAndHalfMode()">
                            <div class="toggle-slider"></div>
                        </div>
                        <span class="toggle-label">Half & Half Pizza</span>
                    </div>

                    <!-- Selected Size Display -->
                    <div class="selected-size-display mb-3" *ngIf="selectedSize">
                        <h6>Selected Size: <span class="badge bg-primary">{{ selectedSize.name | titlecase }} - ${{ selectedSize.price }}</span></h6>
                    </div>

                    <!-- Half Selector -->
                    <div class="half-selector" *ngIf="isHalfAndHalfMode">
                        <div class="half-label">Select Half to customize</div>
                        <div class="half-buttons">
                            <button class="half-btn" 
                                [disabled]="loading"
                                [class.inactive]="selectedHalf !== 'left'"
                                (click)="selectedHalf = 'left'">
                                Left Half
                            </button>
                            <button class="half-btn" 
                                [disabled]="loading"
                                [class.inactive]="selectedHalf !== 'right'"
                                (click)="selectedHalf = 'right'">
                                Right Half
                            </button>
                        </div>
                    </div>

                    <!-- Type Info -->
                    <div class="type-info mb-3" *ngIf="selectedSubCategory">
                        <h6>Type: {{ selectedSubCategory.name | titlecase }}</h6>
                    </div>

                    <!-- Toppings Section -->
                    <div class="toppings-section">
                        <h6>Choose Ingredients</h6>
                        
                        <div *ngFor="let topic of topics" class="mb-2">
                            <div class="ingredient-wrapper">
                                <button class="topping-dropdown" 
                                    *ngIf="!loading"
                                        [class.selected]="isIngredientSelected(topic.id)">
                                    <!-- <div class="ingredient-info" (click)="toggleIngredient(topic)">
                                        <img [src]="topic.avatar" [alt]="topic.name" style="width: 20px; height: 20px; margin-right: 8px; border-radius: 50%;">
                                        <span class="ingredient-name">{{ topic.name | titlecase }}</span>
                                        <span class="price-tag">${{ topic.price }}</span>
                                    </div> -->
                                    <!-- In the toppings section, update the price display -->
                                    <div class="ingredient-info" (click)="toggleIngredient(topic)">
                                        <img [src]="topic.avatar" [alt]="topic.name" style="width: 20px; height: 20px; margin-right: 8px; border-radius: 50%;">
                                        <span class="ingredient-name">{{ topic.name | titlecase }}</span>
                                        <span class="price-tag">
                                            ${{ getTopicPrice(topic) }}
                                            <small *ngIf="topic.sizes?.length > 0 && selectedSize" class="text-muted">
                                                ({{ selectedSize.name }})
                                            </small>
                                        </span>
                                    </div>
                                    <div class="ingredient-actions">
                                        <span class="quantity-badge" *ngIf="getIngredientQuantity(topic.id, isHalfAndHalfMode ? selectedHalf : 'whole') > 0">
                                            {{ getIngredientQuantity(topic.id, isHalfAndHalfMode ? selectedHalf : 'whole') }}x
                                        </span>
                                        <i class="bx bx-plus-circle add-more" 
                                        (click)="showAddMultiple(topic); $event.stopPropagation()"
                                        title="Add multiple"></i>
                                    </div>
                                </button>
                            </div>
                        </div>
                        
                        <div *ngIf="topics.length === 0 && !loading" class="alert alert-info">
                            No ingredients available for this selection.
                        </div>
                    </div>

                    <!-- Quantity Input Modal -->
                    <div class="quantity-modal-overlay" *ngIf="showQuantityInput" (click)="hideQuantityInput()">
                        <div class="quantity-modal" (click)="$event.stopPropagation()">
                            <div class="quantity-modal-header">
                                <h6>Add {{ selectedIngredientForQuantity?.name | titlecase }}</h6>
                                <button class="close-btn" (click)="hideQuantityInput()">
                                    <i class="bx bx-x"></i>
                                </button>
                            </div>
                            
                            <div class="quantity-modal-body">
                                <!-- Half selector for quantity input -->
                                <div class="half-selector mb-3" *ngIf="isHalfAndHalfMode">
                                    <div class="half-label">Add to which half?</div>
                                    <div class="half-buttons small">
                                        <button type="button" class="half-btn small" 
                                                [class.active]="quantityHalf === 'left'"
                                                [class.inactive]="quantityHalf !== 'left'"
                                                (click)="quantityHalf = 'left'">
                                            Left Half
                                        </button>
                                        <button type="button" class="half-btn small" 
                                                [class.active]="quantityHalf === 'right'"
                                                [class.inactive]="quantityHalf !== 'right'"
                                                (click)="quantityHalf = 'right'">
                                            Right Half
                                        </button>
                                        <!-- <button type="button" class="half-btn small" 
                                                [class.active]="quantityHalf === 'whole'"
                                                [class.inactive]="quantityHalf !== 'whole'"
                                                (click)="quantityHalf = 'whole'">
                                            Whole
                                        </button> -->
                                    </div>
                                </div>
                                
                                <!-- Price info -->
                                <div class="price-info mb-3" *ngIf="selectedIngredientForQuantity">
                                    <span>Price per item:</span>
                                    <strong>${{ getTopicPrice(selectedIngredientForQuantity) }}</strong>
                                    <small *ngIf="selectedIngredientForQuantity.sizes?.length > 0 && selectedSize" class="text-muted" style="color: #fff !important;">
                                        ({{ selectedSize.name }} size)
                                    </small>
                                </div>
                                
                                <!-- Quantity selector -->
                                <div class="quantity-selector">
                                    <label>Quantity:</label>
                                    <div class="quantity-input-group">
                                        <button type="button" class="quantity-btn" (click)="quantity = quantity > 1 ? quantity - 1 : 1">
                                            <i class="bx bx-minus"></i>
                                        </button>
                                        <input type="number" [(ngModel)]="quantity" min="1" class="quantity-input" (keyup.enter)="addMultipleIngredients()">
                                        <button type="button" class="quantity-btn" (click)="quantity = quantity + 1">
                                            <i class="bx bx-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                
                                <!-- Total price -->
                                <div class="total-price-info mb-3" *ngIf="selectedIngredientForQuantity">
                                    <span>Total:</span>
                                    <strong class="price">${{ (getTopicPrice(selectedIngredientForQuantity) * quantity) | number:'1.2-2' }}</strong>
                                    <!-- <span *ngIf="quantityHalf !== 'whole' && isHalfAndHalfMode" class="half-note">(50% for half)</span> -->
                                </div>

                            </div>
                            
                            <div class="quantity-modal-footer">
                                <button type="button" class="btn btn-secondary" (click)="hideQuantityInput()">Cancel</button>
                                <button type="button" class="btn btn-primary" (click)="addMultipleIngredients()">
                                    Add {{ quantity }} {{ quantity > 1 ? 'Items' : 'Item' }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Product Quantity Selection -->
                    <div class="product-quantity-section mt-3">
                        <h6>Product Quantity</h6>
                        <div class="product-quantity-selector">
                            <button type="button" class="quantity-btn" (click)="productQuantity = productQuantity > 1 ? productQuantity - 1 : 1">
                                <i class="bx bx-minus"></i>
                            </button>
                            <input type="number" [(ngModel)]="productQuantity" min="1" class="product-quantity-input">
                            <button type="button" class="quantity-btn" (click)="productQuantity = productQuantity + 1">
                                <i class="bx bx-plus"></i>
                            </button>
                        </div>
                    </div>

                    <!-- Add to Cart Button with Total -->
                    <div class="cart-footer">
                        <div class="total-price mb-2">
                            <span>Total per item:</span>
                            <span class="price">${{ calculateItemPrice() | number:'1.2-2' }}</span>
                        </div>
                        <div class="total-price mb-2 grand-total">
                            <span>Grand Total ({{ productQuantity }} {{ productQuantity === 1 ? 'item' : 'items' }}):</span>
                            <span class="price">${{ calculateGrandTotal() | number:'1.2-2' }}</span>
                        </div>
                        <button class="add-to-cart-btn" (click)="addToCart()" [disabled]="!selectedSize && selectedCategory.has_sizes">
                            <i class="bx bx-shopping-cart"></i>
                            Add To Cart
                        </button>
                        <div *ngIf="selectedCategory.has_sizes && !selectedSize" class="text-danger small mt-2">
                            Please select a size first
                        </div>
                    </div>
                </div>
            </div>

            <!-- Preview Area -->
            <div class="col-md-8 mt-3">
                <div class="preview-container">
                    <div class="base-image" [class.half-and-half]="isHalfAndHalfMode">
                        <img [src]="selectedCategory.avatar" [alt]="selectedCategory.name" class="img-fluid">
                        
                        <!-- Whole ingredients -->
                        <ng-container *ngIf="!isHalfAndHalfMode">
                            <div *ngFor="let ingredient of selectedIngredients" 
                                 class="ingredient-overlay"
                                 [style.backgroundImage]="'url(' + ingredient.avatar + ')'">
                            </div>
                        </ng-container>
                        
                        <!-- Half & Half mode ingredients -->
                        <ng-container *ngIf="isHalfAndHalfMode">
                            <!-- Left half ingredients -->
                            <div *ngFor="let ingredient of getIngredientsByHalf('left')" 
                                 class="ingredient-overlay left-half"
                                 [style.backgroundImage]="'url(' + ingredient.avatar + ')'">
                            </div>
                            
                            <!-- Right half ingredients -->
                            <div *ngFor="let ingredient of getIngredientsByHalf('right')" 
                                 class="ingredient-overlay right-half"
                                 [style.backgroundImage]="'url(' + ingredient.avatar + ')'">
                            </div>
                            
                            <!-- Whole pizza ingredients -->
                            <div *ngFor="let ingredient of getIngredientsByHalf('whole')" 
                                 class="ingredient-overlay"
                                 [style.backgroundImage]="'url(' + ingredient.avatar + ')'">
                            </div>
                        </ng-container>
                        
                        <!-- Half divider line -->
                        <div *ngIf="isHalfAndHalfMode" class="half-divider"></div>
                    </div>
                    
<!-- Selected Ingredients List -->
<div class="selected-ingredients mt-3">
    <h5>Your {{ selectedCategory.name | titlecase }} includes:</h5>
    
    <!-- Base price with size -->
    <div class="list-group-item d-flex justify-content-between">
        <span>
            {{ selectedCategory.name | titlecase }} Base 
            <span *ngIf="selectedSize" class="text-muted">({{ selectedSize.name | titlecase }})</span>
        </span>
        <span>${{ getBasePrice() | number:'1.2-2' }}</span>
    </div>
    
    <!-- Whole ingredients -->
    <div *ngIf="getIngredientsByHalf('whole').length > 0">
        <h6 class="mt-2">Whole {{ selectedCategory.name | titlecase }}:</h6>
        <ul class="list-group mb-2">
            <li *ngFor="let ingredient of getIngredientsByHalf('whole')" class="list-group-item d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <img [src]="ingredient.avatar" [alt]="ingredient.name" style="width: 25px; height: 25px; margin-right: 10px; border-radius: 50%;">
                    <span>{{ ingredient.name | titlecase }}</span>
                    <span class="badge bg-secondary ms-2">{{ ingredient.quantity || 1 }}x</span>
                    <!-- Show size info if applicable -->
                    <!-- <span *ngIf="selectedSize && ingredient.originalSizes?.length > 0" class="badge bg-info ms-1">
                        {{ getIngredientSizeName(ingredient) }}
                    </span> -->
                </div>
                <div>
                    <span class="me-2">${{ (getCurrentIngredientPrice(ingredient) * (ingredient.quantity || 1)) | number:'1.2-2' }}</span>
                    <button type="button" class="btn-close" (click)="removeIngredient(ingredient.id, 'whole')"></button>
                </div>
            </li>
        </ul>
    </div>
    
    <!-- Left half ingredients -->
    <div *ngIf="isHalfAndHalfMode && getIngredientsByHalf('left').length > 0">
        <h6 class="mt-2">Left Half:</h6>
        <ul class="list-group mb-2">
            <li *ngFor="let ingredient of getIngredientsByHalf('left')" class="list-group-item d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <img [src]="ingredient.avatar" [alt]="ingredient.name" style="width: 25px; height: 25px; margin-right: 10px; border-radius: 50%;">
                    <span>{{ ingredient.name | titlecase }}</span>
                    <span class="badge bg-secondary ms-2">{{ ingredient.quantity || 1 }}x</span>
                    <!-- Show size info if applicable -->
                    <!-- <span *ngIf="selectedSize && ingredient.originalSizes?.length > 0" class="badge bg-info ms-1">
                        {{ getIngredientSizeName(ingredient) }}
                    </span> -->
                </div>
                <div>
                    <span class="me-2">${{ (getCurrentIngredientPrice(ingredient) * (ingredient.quantity || 1)) | number:'1.2-2' }}</span>
                    <button type="button" class="btn-close" (click)="removeIngredient(ingredient.id, 'left')"></button>
                </div>
            </li>
        </ul>
    </div>
    
    <!-- Right half ingredients -->
    <div *ngIf="isHalfAndHalfMode && getIngredientsByHalf('right').length > 0">
        <h6 class="mt-2">Right Half:</h6>
        <ul class="list-group mb-2">
            <li *ngFor="let ingredient of getIngredientsByHalf('right')" class="list-group-item d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <img [src]="ingredient.avatar" [alt]="ingredient.name" style="width: 25px; height: 25px; margin-right: 10px; border-radius: 50%;">
                    <span>{{ ingredient.name | titlecase }}</span>
                    <span class="badge bg-secondary ms-2">{{ ingredient.quantity || 1 }}x</span>
                    <!-- Show size info if applicable -->
                    <!-- <span *ngIf="selectedSize && ingredient.originalSizes?.length > 0" class="badge bg-info ms-1">
                        {{ getIngredientSizeName(ingredient) }}
                    </span> -->
                </div>
                <div>
                    <span class="me-2">${{ (getCurrentIngredientPrice(ingredient) * (ingredient.quantity || 1)) | number:'1.2-2' }}</span>
                    <button type="button" class="btn-close" (click)="removeIngredient(ingredient.id, 'right')"></button>
                </div>
            </li>
        </ul>
    </div>
    
    <div *ngIf="selectedIngredients.length === 0" class="list-group-item text-muted">
        No additional ingredients selected yet
    </div>
    
    <!-- Item total -->
    <div class="list-group-item d-flex justify-content-between fw-bold mt-2">
        <span>Item Total:</span>
        <span>${{ calculateItemPrice() | number:'1.2-2' }}</span>
    </div>
    
    <!-- Quantity and grand total -->
    <div class="list-group-item d-flex justify-content-between text-primary mt-1">
        <span>Quantity: {{ productQuantity }}</span>
        <span>Grand Total: ${{ calculateGrandTotal() | number:'1.2-2' }}</span>
    </div>
</div>
                </div>
            </div>
        </div>

        <!-- Loading/Empty State -->
        <div *ngIf="!selectedCategory && categories.length > 0" class="row">
            <div class="col-12 text-center">
                <p>Please select a food category to start customizing</p>
            </div>
        </div>
        
        <div *ngIf="loading" class="row">
            <div class="col-12 text-center">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>